<template>
    <div>
        <a-modal :visible="isShow" width="960px" title="从通讯簿选择" :footer="null" @cancel="cancel" class="sender_modal">
            <search-box :conditions="conditions" @search="searchSenderList">
                <template #btn>
                    <a-button class="btn_add" @click="showAddModal"><img src="~@/assets/images/function-service/ic_add.png" width="12px" height="12px" />新增寄件人</a-button>
                </template>
            </search-box>
            <a-radio-group v-model="senderId" class="table_wrapper">
                <a-table :data-source="senderList" :columns="columns" :pagination="false" rowKey="id" :customRow="(record)=>{return {on:{click:()=>this.senderId=record.id}}}" ref="table">
                    <template slot="radio" slot-scope="text,record">
                        <a-radio :value="record.id" />
                    </template>
                    <template slot="operation" slot-scope="text,record">
                        <a-icon type="edit" class="img_edit" @click.stop="showEditModal(record)" />
                    </template>
                </a-table>
                <infinite-loading @infinite="loadMore" :distance="54" spinner="spiral" ref="infinite">
                    <div slot="no-more" class="mt10">没有更多寄件人</div>
                    <span slot="no-results"></span>
                </infinite-loading>
            </a-radio-group>
            <div class="btn_confirm">
                <a-button type="primary" @click="ok">确定选择</a-button>
            </div>
        </a-modal>
        <add-sender-modal v-model="isShowAddModal" @ok="addSender" />
        <edit-sender-modal v-model="isShowEditModal" :editItem="currentEditItem" @ok="editSender" />
    </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import SearchBox from '@/components/common/SearchBox'
import AddSenderModal from '@/components/common/address/AddSenderModal'
import EditSenderModal from '@/components/common/address/EditSenderModal'

export default {
    name: 'senderModal',
    components: {
        InfiniteLoading,
        SearchBox,
        AddSenderModal,
        EditSenderModal
    },
    model: {
        prop: 'isShow',
        event: 'hidden'
    },
    props: {
        isShow: {
        type: Boolean,
        },
    },
    data () {
        return {
            columns: [
                {
                    dataIndex: 'radio',
                    width: '3%',
                    align: 'center',
                    scopedSlots: { customRender: 'radio' }
                },
                {
                    title: '联系人',
                    dataIndex: 'seller_name',
                    width: '20%',
                },
                {
                    title: '联系电话',
                    dataIndex: 'tel',
                    width: '25%',
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    width: '8%',
                    align: 'center',
                    scopedSlots: { customRender: 'operation' },
                },
            ],
            conditions: [
                {
                    key: 'keywords',
                    value: '',
                    placeholder: '输入关键字搜索通讯簿'
                },
            ],
            senderList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            senderId: null,
            isShowAddModal: false,
            isShowEditModal: false,
            currentEditItem: {},
            reqParams: {},
        }
    },
    methods: {
        loadMore ($state) {
            this.getSenderList().then(list => {
                if (list.length > 0) {
                    this.senderList = this.senderList.concat(list)

                    if (this.senderList.length >= this.total) {
                        $state.complete()
                    } else {
                        $state.loaded()
                    }
                } else {
                    $state.complete()
                }
            }).catch(() => {
                $state.loaded()
            })
        },
        searchSenderList (params) {
            this.currentPage = 1
            this.senderList = []
            this.conditions.value = params.keywords
            this.$refs.infinite.$emit('$InfiniteLoading:reset')
        },
        getSenderList () {
            return new Promise((resolve, reject) => {
                var _this = this;

                _this.$util.api('/address/send/list',{
                    offset: (_this.currentPage - 1) * _this.pageSize,
                    limit: _this.pageSize,
                    keywords: _this.conditions.value
                },function(res){
                    if(res.code == 10000){
                        var list = res.data.list;
                        
                        _this.total = res.data.total;
                        _this.currentPage = _this.currentPage + 1;

                        for(var i = 0; i < res.data.list.length; i++){
                            if(parseInt(res.data.list[i].is_default) == 1){
                                _this.senderId = res.data.list[i].id;
                                break;
                            }
                        }

                        resolve(list)
                    }
                });
            })
        },
        ok () {
            const sender = this.senderList.find(({ id }) => id === this.senderId)
            this.$emit('change', sender)
            this.cancel()
        },
        cancel () {
            this.$emit('hidden', false)
        },
        showEditModal (item) {
            this.currentEditItem = item
            this.isShowEditModal = true
        },
        showAddModal () {
            this.isShowAddModal = true
        },
        addSender () {
            this.currentPage = 1
            this.senderList = []
            this.conditions.value = ''
            this.$refs.infinite.$emit('$InfiniteLoading:reset')
        },
        editSender (data) {
            const { name, tel } = data
            this.currentEditItem.seller_name = name
            this.currentEditItem.tel = tel
        }
    },
}
</script>

<style scoped>
.table_wrapper {
    height: 378px;
    overflow: auto;
    width:912px;
}

.sender_modal >>> .ant-modal-header {
    border-top: 5px solid #fd5902;
    text-align: center;
}
.img_edit {
    font-size: 17px;
    cursor: pointer;
}
.btn_add {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fd5902;
    /* padding: 0 9px; */
}
.btn_add img {
    margin-right: 5px;
}

.sender_modal >>> .ant-table-thead th {
    background: #ffffff;
}

.sender_modal >>> .ant-table-tbody tr:nth-child(odd) {
    background: #fafafa;
}

.btn_confirm {
    text-align: center;
    margin-top: 20px;
}
.btn_confirm >>> .ant-btn {
    height: 34px;
    padding: 0 22px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/express/SenderModal.vue